export const SPECS = {
  skipMemberAreaAutoInstall: 'specs.restaurants.skipMemberAreaAutoInstall',
  seo: 'specs.restaurants.oloSeo',
  enableMultiLocation: 'specs.restaurants.OLO.livesite.enableMultiLocation',
  createCart: 'specs.restaurants.livesite.createCart',
  openItemModalBeforeDispatch: 'specs.restaurants.openItemModalBeforeDispatch',
  editCartItem: 'specs.restaurants.OLO.livesite.editCartItem',
  truncateMenuItemsOnEditorToValue:
    'specs.restaurants.OLO.livesite.truncateMenuItemsOnEditorToValue',
  OLOGfppsRedesign: 'specs.restaurants.OLO.livesite.OLOGfppsRedesign',
  calculateFirstAvailableTimeSlot: 'specs.restaurants.OLO.livesite.calculateFirstAvailableTimeSlot',
  featuredItemDesign: 'specs.restaurants.OLO.livesite.featuredItemDesign',
  cartButtonMobileSettings: 'specs.restaurants.OLO.livesite.cartButtonMobileSettings',
  ooiItemModal: 'specs.restaurants.olo.itemModal',
  ecomApi: 'specs.restaurants.OLO.livesite.ecomAPI',
  supportStreetAddress: 'specs.restaurants.OLO.livesite.supportStreetAddress',
  multipleImages: 'specs.restaurants.OLO.livesite.multiple-images',
  sectionItemAvailability: 'specs.restaurants.OLO.livesite.sectionItemAvailability',
} as const;
